export const DATA_CY_FOOTER_LIKE_BUTTON = 'footer-like-button';
export const DATA_CY_FOOTER_SHARE_BUTTON = 'footer-share-button';
export const DATA_CY_FOOTER_TIP_BUTTON = 'footer-tip-button';

export const DATA_CY_FOOTER_LIKE_BUTTON_COMPANY = 'company-footer-like-button';
export const DATA_CY_FOOTER_SHARE_BUTTON_COMPANY =
  'company-footer-share-button';
export const DATA_CY_FOOTER_TIP_BUTTON_COMPANY = 'company-footer-tip-button';
export const DATA_CY_STREAM_ITEM_OPTION_BUTTON = 'stream-item-option-button';
export const DATA_CY_STREAM_ITEM_OPTION_BUTTON_COMPANY =
  'stream-item-option-button_company';
export const DATA_CY_STREAM_COMMENT_ICON = 'stream-comment-icon';
export const DATA_CY_STREAM_COMMENT_ICON_COMPANY =
  'company-stream-comment-icon';

// Guest Footer
export const DATA_CY_POST_GUEST_FOOTER = 'post-guest-footer';
export const DATA_CY_POST_GUEST_FOOTER_LIKES = 'post-guest-footer-likes';
export const DATA_CY_POST_GUEST_FOOTER_DISLIKES = 'post-guest-footer-dislikes';
export const DATA_CY_POST_GUEST_FOOTER_REPLIES = 'post-guest-footer-replies';
export const DATA_CY_POST_GUEST_FOOTER_SHARES = 'post-guest-footer-shares';

// Stream Item Option
export const DATA_CY_POST_STREAM_ITEM_OPTION = 'post-stream-item-option';

